import * as types from "../types";

const initialState = {
    loading: false,
    accessToken: null,
    auction_group:null,
    uploadedAuctionResult: null,
    error: null
}

export default function fetchAuctionUploadedListReducer(state = initialState, action){
    
    switch(action.type){
        case types.FETCH_UPLOADED_AUCTION_REQUEST :
            return{
                ...state,
                loading: true,
                accessToken: action.payload.accessToken,
                auction_group:action.payload.auction_group,
            }

        case types.FETCH_UPLOADED_AUCTION_SUCCESS :
            return{
                ...state,
                loading: false,
                uploadedAuctionResult: action.payload.uploadedAuctionResult,
            }

        case types.FETCH_UPLOADED_AUCTION_FAILURE :
            return{
                ...state,
                loading: false,
                accessToken: null,
                auction_group:null,
                uploadedAuctionResult: null,
                error: action.payload.error
            }

        default :
        return state;

    }

}